const PopoverArrow: React.FC<{ arrowStyles }> = ({ arrowStyles }) => {
  return <div style={arrowStyles}></div>;
};

export default PopoverArrow;
